import Tippy from "@tippyjs/react";
import { FC } from "react";
import styled from "styled-components";
import "tippy.js/dist/tippy.css";

import { formatEuro, getAvatarImagePath } from "../common/constants";
import { TopItemData } from "../common/types";

const StyledTopItems = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
`;

const StyledTopItem = styled.div`
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-bottom: 0.5rem;
    object-fit: cover;
  }

  h4 {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }

  p {
    font-size: 0.8rem;
    margin: 2px 0;
  }
`;

type TopItemsProps = {
  data: TopItemData[];
};

export const TopItems: FC<TopItemsProps> = ({ data }) => {
  return (
    <StyledTopItems>
      {data.map((item) => (
        <StyledTopItem key={item.itemKey}>
          {item.type === "a" && (
            <img src={getAvatarImagePath(item.itemKey)} alt={item.itemKey} />
          )}
          {item.type === "b" && <h4>{item.itemName}</h4>}

          <p
            style={{
              fontSize: "0.7rem",
              color: "#999",
              wordBreak: "break-all",
              fontStyle: "italic",
            }}
          >
            {item.itemKey}
          </p>
          <p>
            <strong>Ventes:</strong> {item.totalPurchases}
          </p>
          <p>
            <Tippy content={`Revenus totaux: ${item.totalRevenue} teeth`}>
              <span style={{ cursor: "pointer" }}>
                {formatEuro(item.totalRevenueEuro)}
              </span>
            </Tippy>
          </p>
          <p>
            <Tippy
              content={
                <div
                  style={{
                    padding: "5px",
                    backgroundColor: "black",
                    color: "white",
                    borderRadius: "4px",
                  }}
                >
                  <strong>Achats par joueur :</strong>
                  <ul style={{ paddingLeft: "20px", margin: "5px 0 0 0" }}>
                    {Object.entries(item.buyers).map(([username, count]) => (
                      <li key={username}>
                        {username}: {count}x
                      </li>
                    ))}
                  </ul>
                </div>
              }
            >
              <span style={{ textDecoration: "underline", cursor: "pointer" }}>
                {item.uniqueBuyers} acheteur(s)
              </span>
            </Tippy>
          </p>
        </StyledTopItem>
      ))}
    </StyledTopItems>
  );
};
